export enum TOrderByType {
  default = "default",
  name = "name",
  max_give = "max_give",
  popularity = "popularity",
}
